"use client";

import { initAll } from '@amplitude/unified';
import { useEffect } from 'react';
import { useCookieConsent } from './CookieConsent';

const AMPLITUDE_API_KEY = '4105cae10e86846c4f1b0547e536f2bb';

export function AmplitudeInit() {
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    // Only initialize if user has consented (default: true)
    if (hasConsent === true) {
      // Initialize Amplitude with the new unified SDK
      initAll(AMPLITUDE_API_KEY, {
        analytics: {
          autocapture: true,
          identityStorage: hasConsent ? "localStorage" : "none",
        },
        sessionReplay: {
          sampleRate: 1,
        },
      });
    }
  }, [hasConsent]);

  return null;
}

